import { IconButton, IconButtonProps, styled } from '@mui/material';

export const IconButtonStyled = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  color: '#0675DD',
  backgroundColor: '#EBF5FF',
  '&:hover': {
    backgroundColor: '#f5f8fc'
  }
}));
